import { Component } from "react";
import { Link } from "react-router-dom";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class AccesoDenegadoSistema extends Component {
  state = {};

  render() {
    return (
      <LayoutPublico>
        <h1 className="h1 text-gray-900">Acceso Denegado</h1>
        <p className="lead text-gray-800">
          No tiene permisos para ingresar al sistema.
        </p>
        <p>
          Contacte a un administrador del sistema{" "}
          <span className="font-weight-bold text-primary">
            Usuarios Externos
          </span>{" "}
          de su entidad para obtener permisos.
        </p>

        <Link to="/" className="button-link">
          <button className="btn btn-primary btn-icon-split text-center">
            <span className="icon text-white-50">
              <i className="fas fa-home"></i>
            </span>
            <span className="text">Página Principal</span>
          </button>
        </Link>
      </LayoutPublico>
    );
  }
}

export default AccesoDenegadoSistema;
